<template>
    <div id="statistics">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>数据统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="margin:10px auto;border:1px solid #ccc;padding:15px 5px 0px;border-radius:4px;background:#fff;box-sizing:border-box" align="left">
            <el-form :inline="true" :model="queryData" style="padding:0 20px">
                <el-row :gutter="10">
                    <el-col align="left" :span="8">
                        <el-form-item label="申请时间：">
                            <el-date-picker v-model="applyTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="applyTimeChange">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col align="left" :span="6">
                        <el-form-item label="诊断医院：">
                            <el-select v-model="queryData.hospId" filterable placeholder="诊断医院">
                                <el-option v-for="item in hospList" :key="item.hospVo.hospId" :label="item.hospVo.hospName" :value="item.hospVo.hospId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col align="left" :span="4">
                        <el-form-item>
                            <el-button icon="el-icon-search" type="success" @click="queryStat()" circle></el-button>
                            <el-button icon="el-icon-delete" type="danger" @click="clear()" circle></el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <el-card class="box-card">
            <div id="emergRatediv" class="leftdiv"></div>
            <div id="genderdiv" class="rightdiv"></div>
            <div style="clear:both; height:100px;"></div>
            <div id="agediv" class="leftdiv"></div>
            <div id="devicediv" class="leftdiv"></div>
            <div style="clear:both; height:100px;"></div>
            <div id="caseStatusdiv" class="centerdiv"></div>
            <div style="clear:both; height:100px;"></div>
        </el-card>
    </div>
    
</template>

<script>
import { Loading } from 'element-ui'
import citySelect from '@/components/city'
export default {
    data(){
        return{
            applyTime:'',
            hospList:[],
            //查询条件
            queryData:{
                hospId:'',
                startApplyTime:'',
                endApplyTime:''
            },
            //急诊数据
            emergRateDate:{
                legendData:[""],
                seriesData:[{
                    "name":'',
                    "value":0
                }]
            },
            //性别数据
            genderDate:{
                legendData:[""],
                seriesData:[{
                    "name":'',
                    "value":0
                }]
            },
            //年龄数据
            ageDate:{
                legendData:[""],
                seriesData:[{
                    "name":'',
                    "value":0
                }]
            },
            //病例状态数据
            caseStatusDate:{
                legendData:[""],
                seriesData:[{
                    "name":'',
                    "value":0
                }]
            },
            //设备数据
            deviceDate:{
                legendData:[""],
                seriesData:[{
                    "name":'',
                    "value":0
                }]
            },
        }
    },
    components:{
      'city-select':citySelect
    },
    mounted(){
        this.getHospList();
        this.queryStat()
    },
    methods:{
        //清空
        clear(){
            this.queryData={
                startApplyTime:'',
                endApplyTime:'',
                hospId:'',
            }
            this.applyTime='';
            this.queryStat();
        },
        //查询
        queryStat(){
            this.emergRateCount()
            this.genderCount()
            this.ageCount()
            this.caseStatusCount()
            this.deviceCount()
        },
        //急诊率
        emergRateCount(){
            this.$ajax.post(this.$domain.countByEmergRate,this.queryData)
            .then((ret)=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——查询急诊率的病例数',res)
                if(res.code=="10"){
                    this.emergRateDate.legendData=res.data.legendData
                    this.emergRateDate.seriesData=res.data.seriesData
                    var emergRateEcharts=this.$echarts.init(document.getElementById("emergRatediv"));
                    emergRateEcharts.setOption({
                        color:['#ff9513','#13bcff','#C1232B'],
                        title : {
                            text: '急诊率统计',
                            x:'center',
                            y:'bottom'
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{b} : {c} 例<br />占比：{d}%"
                        },
                        toolbox:{
                            top:16,
                            right:40,
                            feature:{
                                dataView:{
                                    title:'文本模式',

                                }
                            }
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: 80,
                            top: 20,
                            bottom: 20,
                            data: this.emergRateDate.legendData,
                        },
                        series : [
                            {
                                name: '',
                                type: 'pie',
                                radius : '65%',
                                data: this.emergRateDate.seriesData,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                }
                else{
                    this.$message.error('查询失败！');
                }
            })
        },
        //性别
        genderCount(){
            this.$ajax.post(this.$domain.countByGender,this.queryData)
            .then((ret)=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——查询各性别的病例数',res)
                if(res.code=="10"){
                    this.genderDate.legendData=res.data.legendData
                    this.genderDate.seriesData=res.data.seriesData
                    var genderEcharts=this.$echarts.init(document.getElementById("genderdiv"));
                    genderEcharts.setOption({
                        color:['#77b2ee','#e77d6d', '#eaa270'],
                        title : {
                            text: '病人性别统计',
                            x:'center',
                            y:'bottom'
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{b} : {c} 例<br />占比：{d}%"
                        },
                        toolbox:{
                            top:16,
                            right:40,
                            feature:{
                                dataView:{
                                    title:'文本模式',

                                }
                            }
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: 80,
                            top: 20,
                            bottom: 20,
                            data: this.genderDate.legendData,
                        },
                        series : [
                            {
                                name: '',
                                type: 'pie',
                                radius : '65%',
                                data: this.genderDate.seriesData,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                }
                else{
                    this.$message.error('查询失败！');
                }
            })
        },
        //年龄段
        ageCount(){
            this.$ajax.post(this.$domain.countByAge,this.queryData)
            .then((ret)=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——查询各年龄段的病例数',res)
                if(res.code=="10"){
                    this.ageDate.legendData=res.data.legendData
                    this.ageDate.seriesData=res.data.seriesData
                    var ageEcharts=this.$echarts.init(document.getElementById("agediv"));
                    ageEcharts.setOption({
                        color:['#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
                               '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                               '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'],
                        title : {
                            text: '病人年龄段统计',
                            x:'center',
                            y:'bottom'
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{b} : {c} 例<br />占比：{d}%"
                        },
                        toolbox:{
                            top:16,
                            right:40,
                            feature:{
                                dataView:{
                                    title:'文本模式',

                                }
                            }
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: 80,
                            top: 20,
                            bottom: 20,
                            data: this.ageDate.legendData,
                        },
                        series : [
                            {
                                name: '',
                                type: 'pie',
                                radius : '65%',
                                data: this.ageDate.seriesData,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                }
                else{
                    this.$message.error('查询失败！');
                }
            })
        },
        //病例状态
        caseStatusCount(){
            this.$ajax.post(this.$domain.countBySatatus,this.queryData)
            .then((ret)=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——查询病例状态的病例数',res)
                if(res.code=="10"){
                    this.caseStatusDate.legendData=res.data.legendData
                    this.caseStatusDate.seriesData=res.data.seriesData
                    var caseStatusEcharts=this.$echarts.init(document.getElementById("caseStatusdiv"));
                    caseStatusEcharts.setOption({
                        // color:['#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
                        //        '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                        //        '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'],
                        title : {
                            text: '病例状态统计',
                            x:'center',
                            y:'bottom'
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{b} : {c} 例<br />占比：{d}%"
                        },
                        toolbox:{
                            top:16,
                            right:40,
                            feature:{
                                dataView:{
                                    title:'文本模式',

                                }
                            }
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: 70,
                            top: 20,
                            bottom: 20,
                            data: this.caseStatusDate.legendData,
                        },
                        series : [
                            {
                                name: '',
                                type: 'pie',
                                radius : '80%',
                                data: this.caseStatusDate.seriesData,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                }
                else{
                    this.$message.error('查询失败！');
                }
            })
        },
        //设备类型
        deviceCount(){
            this.$ajax.post(this.$domain.countByDevice,this.queryData)
            .then((ret)=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——查询设备类型的病例数',res)
                if(res.code=="10"){
                    this.deviceDate.legendData=res.data.legendData
                    this.deviceDate.seriesData=res.data.seriesData
                    var deviceEcharts=this.$echarts.init(document.getElementById("devicediv"));
                    deviceEcharts.setOption({
                        // color:['#C1232B','#B5C334','#FCCE10','#E87C25','#27727B',
                        //        '#FE8463','#9BCA63','#FAD860','#F3A43B','#60C0DD',
                        //        '#D7504B','#C6E579','#F4E001','#F0805A','#26C0C0'],
                        title : {
                            text: '设备类型统计',
                            x:'center',
                            y:'bottom'
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{b} : {c} 例<br />占比：{d}%"
                        },
                        toolbox:{
                            top:16,
                            right:40,
                            feature:{
                                dataView:{
                                    title:'文本模式',

                                }
                            }
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            right: 80,
                            top: 20,
                            bottom: 20,
                            data: this.deviceDate.legendData,
                        },
                        series : [
                            {
                                name: '',
                                type: 'pie',
                                radius : '65%',
                                data: this.deviceDate.seriesData,
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    })
                }
                else{
                    this.$message.error('查询失败！');
                }
            })
        },
        //申请时间段选择
        applyTimeChange(val){
            this.queryData.startApplyTime=this.$common.format(val[0],'yyyy-MM-dd')+' 00:00:00';
            this.queryData.endApplyTime=this.$common.format(val[1],'yyyy-MM-dd')+' 23:59:59';
        },
        //获得医院列表
        getHospList(code,level){
            this.$ajax.post(this.$domain.listHospInfo,{
                page:1,
                rows:1000
            })
            .then(ret=>{
                var res=ret.data;
                this.$common.getConsole('statistics.vue——获得医院列表',ret.data);
                if(res.code=="10"){
                    this.hospList=res.data.list;
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(res)
                }
            })
        },
    }
}
</script>

<style>
    #statistics{
        width:100%;
        min-width: 1400px;
        padding:0 5%;
        box-sizing: border-box;
    }
    #statistics .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    #statistics .selectCondition{
        width:76%;
        margin: 0 auto;
    }
    #statistics .leftdiv{
        float: left;
        width: 49%;
        height:300px;
    }
    #statistics .centerdiv{
        margin: auto;
        width: 60%;
        height:300px;
    }
    #statistics .rightdiv{
        float:right;
        width: 49%;
        height:300px;
    }
    #statistics .el-form-item{
        margin-left:0 !important;
        display: flex;
        justify-content: flex-start
    }
    #statistics .box-card{
        margin-bottom:40px;
        padding-bottom:20px;
    }
</style>



// WEBPACK FOOTER //
// src/page/statistics.vue